import React from "react";
import classNames from "classnames";
import { Button } from "@design-system/Button/Button";
import { LeftArrowIcon } from "@icons";
import { noop } from "@common/helpers/function";
import { ResendCode } from "@components/auth/CodeVerification/ResendCode";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { CodeVerification } from "@components/auth/CodeVerification/CodeVerification";
import { HStack } from "@design-system/HStack/HStack";
import { VStack } from "@design-system/VStack/VStack";
import animation from "../layout/OnboardingLayout.module.scss";
import styles from "./RegisterCodeVerification.module.scss";

interface Props {
    email: string;
    onSuccess?(): Promise<void>;
    requestVerification(): Promise<void>;
    verifyCode(code: string): Promise<boolean>;
    onBack(): void;
}

export const RegisterCodeVerification: React.FC<Props> = ({
    email,
    verifyCode,
    requestVerification,
    onSuccess,
    onBack,
}) => (
    <div className={classNames(styles.contentContainer, animation.fadeIn)}>
        <header className={styles.header}>
            <h1 className={styles.title}>Check your email</h1>

            <p>
                We just sent a 6-digit code to {email}
                <br />
                Proceed by typing your code below.
            </p>
        </header>

        <section className={styles.code}>
            <CodeVerification
                phoneOrEmail={email}
                request={requestVerification}
                verify={verifyCode}
                onSuccess={onSuccess ?? noop}
                lead={null}
                resend={null}
                requestOnMount={false}
                renderSubmit={({ isValid, isSubmitting }) => (
                    <VStack gap={40}>
                        <HStack as="section" justify="center">
                            <ResendCode
                                request={requestVerification}
                                btnSize="lg"
                            />
                        </HStack>

                        <HStack as="footer" justify="center" gap={12}>
                            <Button
                                variant="primary"
                                onClick={onBack}
                                size="xl"
                                iconOnly
                                aria-label="Go back"
                            >
                                <LeftArrowIcon />
                            </Button>

                            <ButtonWithLoader
                                type="submit"
                                variant="primary"
                                loading={isSubmitting}
                                disabled={!isValid}
                                size="xl"
                            >
                                Verify
                            </ButtonWithLoader>
                        </HStack>
                    </VStack>
                )}
            />
        </section>
    </div>
);
